import React, { useEffect } from 'react'
import { PAGE_URL } from '../../constants'
import { redirectToBackendApp } from '../../router/redirections'
import { RouteAppComponentProps } from '../../router/routes'
import store from '../../store'
import { ActionType } from '../../store/home/action'
import { setPageTitle } from '../../utils/hook'
import AppNotAuthorizedPageView from './view'

function AppNotAuthorizedPage(props: RouteAppComponentProps): JSX.Element {
  useEffect(() => {
    setPageTitle(window)(props.pageName)()
  })
  useEffect(() => {
    store.dispatch({
      type: ActionType.SET_IS_LOADING,
      payload: { isLoading: false }
    })
  }, [])
  return (
    <AppNotAuthorizedPageView
      onSignInClick={() =>
        redirectToBackendApp(window.location)(PAGE_URL.LOGIN)
      }
    />
  )
}

export default AppNotAuthorizedPage
